import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function TargetAudience() {
  const isFor = ['Mujeres de 65 años o más que viven en USA y quieren mantenerse activas.', 'Abuelas que desean jugar con sus nietos en el suelo sin sufrir al levantarse.', 'Personas que sufren de osteoartritis, artritis o dolores articulares crónicos.', 'Mujeres que prefieren soluciones naturales antes que químicos de farmacia.'];
  const isNotFor = ['Personas que buscan una "cura milagrosa" de un solo día sin cambiar sus hábitos.', 'Quienes no están dispuestos a cocinar recetas sencillas en casa.', 'Personas que solo creen en cirugías y fármacos de alto costo.'];
  return <section className="py-20 px-6 bg-white" data-id="element-137">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-138">
        <FadeIn data-id="element-139">
          <div className="bg-brand-cream p-8 rounded-3xl h-full" data-id="element-140">
            <h3 className="text-2xl font-bold mb-6 flex items-center" data-id="element-141">
              <CheckCircle2Icon className="w-8 h-8 text-green-600 mr-3" data-id="element-142" />
              Esto ES para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-143">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-144">
                  <span className="text-green-600 font-bold mr-3 mt-1" data-id="element-145">✓</span>
                  <span data-id="element-146">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-147">
          <div className="bg-brand-terracottaLight p-8 rounded-3xl h-full" data-id="element-148">
            <h3 className="text-2xl font-bold mb-6 flex items-center" data-id="element-149">
              <XCircleIcon className="w-8 h-8 text-brand-terracotta mr-3" data-id="element-150" />
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-151">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-152">
                  <span className="text-brand-terracotta font-bold mr-3 mt-1" data-id="element-153">
                    ✕
                  </span>
                  <span data-id="element-154">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}